import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class AssetStackItem extends EquatableKeyStackItem {
    asAsset() {
        return this.value;
    }
}

//# sourceMappingURL=AssetStackItem.js.map
